import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

import legalConfig from './legalConfig';
import './legal.scss';

const LegalLayout = ({ eyebrow, title, description, children }) => {
    const location = useLocation();

    useEffect(() => {
        const previousTitle = document.title;
        document.title = `${title} | ${legalConfig.institutionName}`;
        window.scrollTo(0, 0);

        return () => {
            document.title = previousTitle;
        };
    }, [title]);

    return (
        <main className="subpage legal-page">
            <header className="legal-hero">
                <div className="legal-hero__content">
                    <p className="legal-eyebrow">{eyebrow}</p>
                    <h1>{title}</h1>
                    <p className="legal-lead">{description}</p>
                    <div className="legal-hero__actions" aria-label="Navegación legal">
                        <Link
                            className={location.pathname === '/politica-de-privacidad' ? 'is-active' : ''}
                            to="/politica-de-privacidad"
                        >
                            Política de privacidad
                        </Link>
                        <Link
                            className={location.pathname === '/eliminacion-de-datos' ? 'is-active' : ''}
                            to="/eliminacion-de-datos"
                        >
                            Eliminación de datos
                        </Link>
                    </div>
                </div>
            </header>

            <div className="legal-content">{children}</div>
        </main>
    );
};

export default LegalLayout;
